<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="显示发票" fontSize="14px" @btnclick="showInvoice"
				:src="require('@/assets/icon/phont.png')">
			</Commonbtn>
		</div>
		<div class="TableWidth" v-if="CusTypeFlog == 0">
			<Commontable :loadingTable="false" colnum=7 :tableData="tableData" :headerData="headerData" height="100%"
				@onRowClick="onRowClick">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:pageNo="pageNo" :pageSize="pageSize" :total="total"></Pagination>
			</div>
		</div>
		<div class="TableWidth" v-else>
			<Commontable :loadingTable="false" colnum=7 :tableData="tableData" :headerData="headerDataTow" height="100%"
				@onRowClick="onRowClick">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:pageNo="pageNo" :pageSize="pageSize" :total="total"></Pagination>
			</div>
		</div>
		<Picturepreview :show="invoiceDialogVisible" :imgsrc="invoiceImageUrl" @hidefn="hideInvoiceDialog">
		</Picturepreview>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Picturepreview from '@/components/picturepreview.vue'
	import headerData from '../fromTable/headerData'
	import headerDataTow from '../fromTable/headerDataTow'
	import {
		CusType,
		GetInvoiceImage
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Picturepreview
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			pageNo: {
				type: Number,
				default: 1
			},
			pageSize: {
				type: Number,
				default: 20
			},
		},
		data: function() {
			return {
				rightboo: false,
				dwonleft: false,
				ptype: '',
				CusTypeFlog: null,
				fromdataadd: [],
				fromdataedit: [],
				headerData: [],
				headerDataTow: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
				invoiceDialogVisible: false,
				invoiceImageUrl: '',
				selectedSBMID: '',
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			console.log(headerDataTow, 'headerDataTow');
			this.QX()
			this.CusType()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == NodeID) {
						this.qus = item.Nodes[index].Nodes
					}
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			// 判断修改是否可用
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					// this.CusTypeState = data.CusType
					if (data.CusType == "") {
						this.CusTypeFlog = 0
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
					}
				}
			},
			Export() {
				this.$emit('Export')
			},
			async showInvoice() {
				if (!this.selectedSBMID) {
					this.$message.warning('请先选择一行数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '正在加载发票...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				})
				let {
					code,
					data,
					message
				} = await GetInvoiceImage({
					SBMID: this.selectedSBMID
				})
				loading.close()
				if (code == 0) {
					if (data && data.toLowerCase().includes('.pdf')) {
						const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
						if (isMobile) {
							window.location.href = data
						} else {
							window.open(data, '_blank')
						}
					} else {
						this.invoiceImageUrl = data
						this.invoiceDialogVisible = true
					}
				} else {
					this.$message.error(message || '获取发票图片失败')
				}
			},
			hideInvoiceDialog() {
				this.invoiceDialogVisible = false
			},
			onRowClick(val) {
				this.selectedSBMID = val.SBMID
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>